import {
  GET_VAULT_ACT_LIST_REQUESTED,
  GET_VAULT_ACT_LIST_FAILED,
  GET_VAULT_ACT_LIST_SUCCESS,
  CLEAR_VAULT_ACTS_LIST_ERROR,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const vaultActListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VAULT_ACT_LIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_VAULT_ACT_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case GET_VAULT_ACT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case CLEAR_VAULT_ACTS_LIST_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default vaultActListReducer;
